var map = {
	"./001.png": "TcP0",
	"./002.png": "nMG2",
	"./003.png": "OQtN",
	"./004.png": "8+zL",
	"./005.png": "mnmo",
	"./006.png": "f+PC",
	"./007.png": "xTr8",
	"./008.png": "pkJX",
	"./009.png": "Fp1+",
	"./010.png": "FdXF",
	"./011.png": "pUNT",
	"./012.png": "1yOe",
	"./013.png": "o9ek",
	"./014.png": "Hylz",
	"./015.png": "OSu0",
	"./016.png": "rek9",
	"./017.png": "+qEA",
	"./018.png": "fyAv",
	"./019.png": "Z4wV",
	"./020.png": "zDvc",
	"./021.png": "En2U",
	"./022.png": "sw6a",
	"./023.png": "ctJX",
	"./024.png": "5Zju",
	"./025.png": "l8X/",
	"./026.png": "wmET",
	"./027.png": "C/Ay",
	"./028.png": "pw9z",
	"./029.png": "bkqW",
	"./050.png": "Xri8",
	"./051.png": "Z59t",
	"./052.png": "I5JH",
	"./053.png": "7jnv",
	"./054.png": "Xx1D",
	"./box1.png": "u9hM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rRlo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen ^\.\/.*\.png$
// module id = rRlo
// module chunks = 0